function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var VaultMainTemplate = require('./main.template.js');
var FileUploadOverlay = require('./overlays/file-upload.js');
var VaultMain = /*#__PURE__*/function () {
  function VaultMain(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, VaultMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.file_upload_overlay = new FileUploadOverlay(this.app, this.mod);
  }
  return _createClass(VaultMain, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container !== '') {
        this.container = container;
      }
      if (!this.container || this.container.trim() === '') {
        this.container = '.saito-container';
      }
      var html = VaultMainTemplate(this.app, this.mod);

      //
      // if scriptorium doesn't exist, append it
      // otherwise, replace its content (for dynamic refresh)
      //
      if (!document.querySelector('.saito-vault')) {
        this.app.browser.addElementToSelector(html, this.container);
      } else {
        this.app.browser.replaceElementBySelector(html, '.saito-vault');
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        document.querySelector('#vault-secure-btn').onclick = function (e) {
          _this.file_upload_overlay.render();
        };
        document.querySelector('#vault-access-link').onclick = function (e) {
          _this.mod.access_file_overlay.render();
        };
      } catch (err) {
        console.error('Vault main attachEvents error:', err);
      }
    }
  }]);
}();
module.exports = VaultMain;